<template>
<section class="special">
<words/>
<keyvis/>
</section>
</template>

<script>
import words from '@/components/words.vue'
import keyvis from '@/components/keyvis.vue'

export default {
  name: 'app',
  components: {
    words,
    keyvis
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.special{
  //height: 860px;
  position: relative;
  @include mq(){
    padding-top: 66px;
  }
  //width: 100%;
  //top: 0;
 // left: 0;
}
</style>
